import Link from 'next/link'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'

export const NoResults = ({ suggestions = [] }: NoResultsProps) => {
  return (
    <div className="text-center py-12">
      <MagnifyingGlassIcon className="mx-auto h-12 w-12 text-gray-400 mb-4" />
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        No results found
      </h3>
      <p className="text-gray-600 text-sm">
        Try broadening your search, removing a scoped filter, or checking your
        spelling.
      </p>
      {suggestions.length > 0 ? (
        <div className="mt-5 flex flex-wrap justify-center gap-2">
          {suggestions.map(suggestion => (
            <Link
              key={suggestion.href}
              href={suggestion.href}
              className="inline-flex rounded-full border border-gray-200 bg-gray-50 px-3 py-1.5 text-sm font-medium text-gray-700 transition hover:border-red-200 hover:bg-red-50 hover:text-vi-red"
            >
              {suggestion.label}
            </Link>
          ))}
        </div>
      ) : null}
    </div>
  )
}

interface NoResultsProps {
  suggestions?: {
    href: string
    label: string
  }[]
}
